import moment from 'moment';
import Swal from "sweetalert2";
import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';
export default {
    name: 'Branches',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        await this.CheckLoginStatus();

        if (!this.loginDetails) {
            this.logout();
            return;
        }

        const allowed =
            this.isAdministratorRole()
            || this.isMinistryUserRole()
            || (this.isFacilityCenterRole() && this.canViewFacilityDepartmentsUi());
        if (!allowed) {
            this.logout();
            return;
        }

        if (this.isFacilityOnlyBranchesView) {
            this.$router.replace({ path: '/FacilityDepartments' });
            return;
        }

        await this.GetInfo();
        if (this.canShowBranchOnboardingQueue) {
            await this.loadOnboardingQueue();
        }
    },

    computed: {
        /** يميّز شاشة «المرافق» عن الصفحات التي تعيد استخدام نفس القالب (مثل الشركات المصنعة). */
        isBranchesDictionaryScreen() {
            return true;
        },
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        },
        canManageBranchesDictionary() {
            return this.isAdministratorRole() || this.isMinistryUserRole();
        },
        canShowBranchOnboardingQueue() {
            return this.isMinistryPharmacyDepartmentRole() || this.isAdministratorRole() || this.isMinistryUserRole();
        },
        isFacilityOnlyBranchesView() {
            return this.isFacilityCenterRole() && !this.canManageBranchesDictionary;
        },
        statsCards() {
            return [
                this.statCard(`إجمالي ${this.ScreenTitle}`, this.Statistics && this.Statistics.count, 'primary', 'ti ti-building-hospital'),
                this.statCard(`${this.ScreenTitle} النشطة`, this.Statistics && this.Statistics.active, 'success', 'ti ti-circle-check'),
                this.statCard(`${this.ScreenTitle} غير النشطة`, this.Statistics && this.Statistics.notActive, 'warning', 'ti ti-eye-off'),
                this.statCard(`${this.ScreenTitle} المحذوفة`, this.Statistics && this.Statistics.deleted, 'danger', 'ti ti-trash'),
            ];
        },
    },

    filters: {
        moment: function (date) {
            if (date === null) {
                return "فارغ";
            }
            return moment(date).format('DD/MM/YYYY');
        },

        momentTime: function (date) {
            if (date === null) {
                return "فارغ";
            }
            return moment(date).format('DD/MM/YYYY || HH:MM');
        }
    },
    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            Search: '',

            ScreenTitle: 'المرافق الصحية',
            ScreenTitleSingle: 'مرفق صحي',
            ScreenTitleSingleAl: 'المرفق',

            Info: [],
            Statistics: [],

            AddDialog: false,

            SelectedItem:'',

            onboardingQueue: [],

            ruleForm: {
                Id: '',
                Name: '',
                Descriptions: '',
                Image: '',
                ImageName: '',
            },
            rules: {
                Name: this.$helper.Required(),
            },
        };
    },



    methods: {

        onboardingStatusLabel(v) {
            const n = Number(v);
            if (!n || Number.isNaN(n)) return 'تشغيلي';
            if (n === 1) return 'تحت الإعداد';
            if (n === 2) return 'في انتظار اعتماد الصيدلة';
            if (n === 3) return 'في انتظار الاعتماد الوزاري';
            return '—';
        },

        async loadOnboardingQueue() {
            if (!this.canShowBranchOnboardingQueue) return;
            try {
                const res = await this.$http.GetBranchesOnboardingQueue();
                this.onboardingQueue = (res.data && res.data.info) ? res.data.info : [];
            } catch {
                this.onboardingQueue = [];
            }
        },

        approveBranchPharmacy(id) {
            Swal.fire({
                title: 'تأكيد الاعتماد الصيدلاني',
                text: 'هل اعتمدت الجرد والأصناف المفعّلة لهذا المرفق؟',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'نعم، اعتماد',
                cancelButtonText: 'إلغاء',
                customClass: { confirmButton: 'btn btn-primary', cancelButton: 'btn btn-label-secondary' },
                buttonsStyling: false,
            }).then((result) => {
                if (!result.isConfirmed) return;
                this.$blockUI.Start();
                this.$http.PharmacyApproveBranchOnboarding(id)
                    .then((response) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'تم', response.data);
                        this.loadOnboardingQueue();
                        this.GetInfo();
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ', (err.response && err.response.data) || 'تعذر الاعتماد');
                    });
            });
        },

        approveBranchMinistry(id) {
            Swal.fire({
                title: 'الاعتماد الوزاري النهائي',
                text: 'بعد الاعتماد يصبح المرفق تشغيلياً بالكامل لرئيس المصحة.',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'اعتماد نهائي',
                cancelButtonText: 'إلغاء',
                customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-label-secondary' },
                buttonsStyling: false,
            }).then((result) => {
                if (!result.isConfirmed) return;
                this.$blockUI.Start();
                this.$http.MinistryApproveBranchOnboarding(id)
                    .then((response) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'تم', response.data);
                        this.loadOnboardingQueue();
                        this.GetInfo();
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ', (err.response && err.response.data) || 'تعذر الاعتماد');
                    });
            });
        },

        goToDepartmentsForBranch(item) {
            if (!item || item.id == null || !this.canViewFacilityDepartmentsUi()) return;
            this.$router.push({
                path: '/FacilityDepartments',
                query: {
                    facilityBranchesId: String(item.id),
                    branchName: item.name || '',
                },
            });
        },

        departmentCountDisplay(item) {
            if (!item) return 0;
            const n = item.facilityDepartmentsCount;
            if (n === null || n === undefined || n === '') return 0;
            return Number(n);
        },

        openFacilityNationalFormulary(branch) {
            if (!branch || branch.id == null) return;
            this.href({
                path: '/FacilityNationalFormulary',
                query: { facilityBranchesId: String(branch.id) },
            });
        },

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            const requestPageSize = this.isFacilityOnlyBranchesView ? 500 : this.pageSize;

            if (!this.Search)
                this.$blockUI.Start();
            this.$http.GetBranches(this.pageNo, requestPageSize, this.Search)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    let info = response.data.info || [];
                    if (this.isFacilityOnlyBranchesView && this.loginDetails && this.loginDetails.branchesId) {
                        const bid = Number(this.loginDetails.branchesId);
                        info = info.filter(x => Number(x.id) === bid);
                    }
                    this.Info = info;
                    if (this.isFacilityOnlyBranchesView) {
                        this.pages = info.length;
                    } else {
                        this.pages = response.data.count;
                    }
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },

        OpentEditDialog(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.Name = item.name;
            this.ruleForm.Descriptions = item.descriptions;
            
        },

        submitEditForm(formName) {
            const formRef = formName || 'ruleFormEdit';
            this.$refs[formRef].validate((valid) => {
                if (valid) {
                    this.ruleForm.Id = Number(this.ruleForm.Id);
                    this.$blockUI.Start();
                    this.$http.EditBranches(this.ruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo();
                            this.ClearForm(this.ruleForm);
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        ChangeStatus(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية تغير حالة العرض  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ChangeStatusBranches(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية الحذف  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteBranches(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الحذف', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        //Upload File
        SelectImage(file) {

            // Check if file is defined
            if (!file) {
                this.$helper.ShowMessage('error', 'خطاء بالعملية', 'يرجى اختيار ملف');
                return;
            }

            let str = file.type; // Access type property safely
            str = str.substring(0, 5);

            // Check if the file type is an image
            if (str !== "image") {
                this.$helper.ShowMessage('error', 'خطاء بالعملية', 'الرجاء التأكد من نوع الملف');
                return;
            }

            var $this = this;
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                $this.ruleForm.ImageName = file.name;
                $this.ruleForm.Image = reader.result;
            };
        }


    }
}
